import { useState } from 'react';

import QaSpecCharacteristicGrid from './QaSpecCharacteristicGrid';

import { useMicrobiological } from 'pages/qa-spec/hooks/useMicrobiological';
import { EDIT_SECTION } from 'pages/qa-spec/components/edit-tab-checker';
import { useGetQaMicrobiologicalCharacteristicsSnapshot } from './snapshot/hooks';

const MicrobiologicalCharacteristic = (props) => {
  const { productId, enumOptions } = props;

  const [isGridEditing, setIsGridEditing] = useState(false);

  const {
    gridInst,
    analysisNotExecuted, // TODO: Update it to analysisExecuted.
    rowData,
    columnDefs,
    saveData,
    loading,
    addNewRow,
    deleteData,
    selectedRow,
    selectRow,
    cancelEdit,
    onCellEditingStopped,
    gridTitle,
  } = useMicrobiological({
    productId,
    isGridEditing,
    enumOptions,
  });

  const {
    microbiologicalCharacteristicsSnapshot,
    analysisNotExecutedSnapshot,
  } = useGetQaMicrobiologicalCharacteristicsSnapshot();

  const onEdit = (isEditing) => {
    setIsGridEditing(isEditing);
  };

  return (
    <QaSpecCharacteristicGrid
      type={EDIT_SECTION.PROD_SPEC_MICROBIOLOGICAL_CHARACTER}
      title={gridTitle}
      loading={loading}
      gridInst={gridInst}
      columnDefs={columnDefs}
      rowData={rowData}
      handleSave={saveData}
      handleAdd={addNewRow}
      handleDelete={deleteData}
      handleCancel={cancelEdit}
      selectedRow={selectedRow}
      onRowSelected={selectRow}
      analysisNotExecuted={analysisNotExecuted}
      analysisNotExecutedSnapshot={analysisNotExecutedSnapshot}
      isShowAnalysisNotExecuted
      productId={productId}
      onCellEditingStopped={onCellEditingStopped}
      snapshotGridValues={microbiologicalCharacteristicsSnapshot}
      onEditChange={onEdit}
      fieldPathTooltip='qaSpecification.productSpecification.analysisNotExecuted4'
    />
  );
};

export default MicrobiologicalCharacteristic;
